import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getWorkerListingSupplyAnalytics } from 'api/admin/listing/getWorkerListingSupplyAnalytics'
import { listingsKeys } from './keys'

type WorkerListingSupplyAnalyticsQueryData = Awaited<
  ReturnType<typeof getWorkerListingSupplyAnalytics>
>

export const useWorkerListingSupplyAnalyticsQuery = (
  listingId: number,
  workerId: number | null,
  options?: Partial<
    UseQueryOptions<
      WorkerListingSupplyAnalyticsQueryData,
      AxiosError,
      WorkerListingSupplyAnalyticsQueryData,
      QueryKey
    >
  >
) => {
  return useQuery<
    WorkerListingSupplyAnalyticsQueryData,
    AxiosError,
    WorkerListingSupplyAnalyticsQueryData,
    QueryKey
  >({
    ...options,
    queryKey: listingsKeys.supplyAnalytics(listingId, workerId),
    queryFn: () => getWorkerListingSupplyAnalytics(listingId, workerId),
    enabled: Boolean(listingId && workerId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
